import { Modal } from 'bootstrap';
import randomGenerator from '../modules/random-generator';
import passwordVisibility from '../modules/password-visibility';
import placeholder from '../modules/placeholder';
import initAliasDeleteModal from '../modules/alias-delete-modal';
import initForwardDeleteModal from '../modules/forward-delete-modal';

const initialize = () => {
    placeholder('eu-temp');
    randomGenerator();
    passwordVisibility();
    initAliasDeleteModal();
    initForwardDeleteModal();

    const appPasswordPremiumEnableBtn = document.getElementById('app-password-premium-enable-btn');
    if (appPasswordPremiumEnableBtn) {
        appPasswordPremiumEnableBtn.addEventListener('click', () => {
            document.getElementById('status').value = 'open';
            document.getElementById('app-password-enable-btn').click();
        });
    }

    const appPasswordEl = document.getElementById('appPasswordModal');
    if (appPasswordEl) {
        const appPasswordModal = new Modal(appPasswordEl, {
            focus: false
        });
        appPasswordModal.hide();
    }

    const appPasswordEnableBtn = document.getElementById('app-password-enable-btn');
    if (appPasswordEnableBtn) {
        appPasswordEnableBtn.addEventListener('click', () => {
            if (!appPasswordEnableBtn.checked) {
                return;
            }

            // if set trial
            if (['trial', 'closed'].includes(document.getElementById('status').value)) {
                // if set trial and no premium left show buy quot window
                // if set trial and has premium show switch to premium confirmation window
                appPasswordEnableBtn.setAttribute('data-bs-toggle', 'modal');
                appPasswordEnableBtn.setAttribute('data-bs-target', '#appPasswordPremiumEnableModal');
                appPasswordEnableBtn.checked = false;

                const appPasswordPremiumEnableModal = new Modal(document.getElementById('appPasswordPremiumEnableModal'));
                if (!appPasswordPremiumEnableModal) {
                    return;
                }
                appPasswordPremiumEnableModal.show();
                return;
            }
            appPasswordEnableBtn.classList.remove('purchase-more');
            appPasswordEnableBtn.setAttribute('data-bs-toggle', '');
        });
    }

    const emailClientSettingsEl = document.getElementById('email-client-settings');
    if (emailClientSettingsEl) {
        emailClientSettingsEl.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            window.open(emailClientSettingsEl.getAttribute('href'), '_blank').focus();
        });
    }
};

export default initialize;
